import React, { useRef, useEffect, memo } from 'react';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

interface DateSearchBoxProps {
    label: string;
    inputValue: string;
    onChange: (inputValue: string) => void;
    hiddenLabel?: boolean;
    placeholder?: string;
}

const DateSearchBox: React.FC<DateSearchBoxProps> = ({ label, inputValue, onChange, hiddenLabel, placeholder }) => {
    const datepickerRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (datepickerRef.current) {
            $(datepickerRef.current).datepicker({
                dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                onSelect: (dateText: string) => {
                    onChange(dateText);
                }
            });
        }

        return () => {
            if (datepickerRef.current) {
                $(datepickerRef.current).datepicker('destroy');
            }
        };

    }, [onChange]);

    return (
        <div className="inline-block">
            {hiddenLabel !== true && (
                <label>
                    {label}:&nbsp;
                </label>
            )}
            <input
                type="text"
                ref={datepickerRef}
                value={inputValue}
                placeholder={placeholder}
                className="light-border p-2 rounded mr-[10px] w-[100px]"
                style={{
                    border: "1px solid #ddd"
                }}
            />
        </div>
    );
};

export default memo(DateSearchBox);